/** @format */

import { useQuery } from '@tanstack/react-query';
import { useAppTranslation } from '../i18n/declarations';
import { NAME_PORTAL_CODE } from '../utils/gatsby/constants';
import { apiRoomDetail } from '../api/apiRoomDetail';

export const useRoomQuery = (roomCode: string) => {
  const { intl } = useAppTranslation();
  const locale = intl.locale;

  return useQuery({
    queryKey: ['room', roomCode],
    queryFn: async () => apiRoomDetail({ roomCode, locale, portalCode: NAME_PORTAL_CODE }),
  });
};
